import { Box } from '@mui/material';
import React from 'react';
import { StyledButton } from '../styles/StyledButtons';
import StyledModal from '../styles/StyledModal';
import { StyledHeading } from '../styles/styles';
import { AIAssistedCreationWizardSteps } from './AIAssistedCreationWizard/AIAssistedCreationWizardSteps';
import { AIAssistedCreationWizardProps } from './AIAssistedCreationWizard/aiAssistedCreationWizardTypes';
import { useAIAssistedCreationWizard } from './AIAssistedCreationWizard/useAIAssistedCreationWizard';

/**
 * AIAssistedCreationWizard - Content generation wizard for fund opportunities
 *
 * This component uses the background job architecture for content generation:
 * 1. Initiates content generation and receives a job ID
 * 2. Polls the job progress API every 2.5-5 seconds
 * 3. Displays real-time progress updates to the user
 * 4. Fetches generated content from job metadata when complete
 *
 * See: CONTENT_GENERATION_API_MIGRATION_GUIDE.md for details
 */
const AIAssistedCreationWizard: React.FC<AIAssistedCreationWizardProps> = (props) => {
  const wizard = useAIAssistedCreationWizard(props);
  const { state, handleExit } = wizard;
  const { open, fundOpportunity, standalone = false } = props;

  console.log('Modal render:', { open, step: state.step, standalone });

  const stepContent = <AIAssistedCreationWizardSteps step={state.step} {...wizard} />;

  const exitButton =
    state.step !== 'initial' && state.step !== 'success' ? (
      <StyledButton
        buttonVariant="inactiveOrCancel"
        onClick={handleExit}
        disabled={state.isUploading}
      >
        Exit
      </StyledButton>
    ) : null;

  if (!standalone) {
    return (
      <StyledModal
        open={open}
        onClose={() => {}}
        title="Documents"
        hideCloseButton={true}
        disableClickAwayClose={true}
        actions={null}
        fullWidth
        maxWidth="lg"
      >
        {stepContent}
      </StyledModal>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Box sx={{ p: 3 }}>
        <StyledHeading headerVariant="heading2" tone="tone1" reduceBottomPadding>
          {fundOpportunity.name}
        </StyledHeading>
        <StyledHeading headerVariant="subheading" tone="tone1" sx={{ mb: 4 }}>
          AI-Assisted Content Creation
        </StyledHeading>

        {stepContent}
        {exitButton && (
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>{exitButton}</Box>
        )}
      </Box>
    </Box>
  );
};

export default AIAssistedCreationWizard;
